exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3nXku251oopS5hW-eaBMNy{padding:20px;background:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"spinner": "_3nXku251oopS5hW-eaBMNy"
};